import React from 'react';
import styled from 'styled-components';
import Navbar from './Navbar';
import Footer from './Footer';
import DesktopMenu from './DesktopMenu';

import img1 from '../images/P1250371thangible.jpg';
import img2 from '../images/9R4A8724.jpg';
import img3 from '../images/04_JED_Betonsalon_SusieRichard.JPG';


const supporters = [
  'Artist Commons',
  'Zinneke',
  'Semaine du Son',
  'Bétonsalon',
  'La Fonderie',
  'Radiophrenia',
  'Chapelle du Grand Hospice',
];

const Trance = () => {
  return (
    <>
      <Navbar />
      <DeskWrap>
        <DesktopMenu />
        <Wrapper>
          <Body>
            <h1>t.r.a.n.c.e</h1>
            <Sub>An ongoing collaboration with Diana Duta</Sub>

            <p>
              t.r.a.n.c.e is an ongoing collaborative project by hypnotherapist and artist Julia E. Dyck and
              sound artist Diana Duta, exploring the hypnotic trance state as a collective, transformative
              experience. Live soundscape, storytelling, and guided meditation combine to open a space for
              metaphoric, somatic, and sensory exploration through the subconscious.
            </p>

            <ImageRow>
              <Img src={img2} alt="t.r.a.n.c.e session, live soundscape and collective trance" />
              <Img src={img1} alt="t.r.a.n.c.e session, guided meditation setup" />
            </ImageRow>

            <Img src={img3} alt="t.r.a.n.c.e session, full room in collective rest" wide />

            <h3>Pleasure/Perspective</h3>
            <p>
              t.r.a.n.c.e's debut LP, <em>Pleasure/Perspective</em>, launched in September 2025 on BBJTC Records
              (Hamburg), funded by Fédération Wallonie-Bruxelles.
            </p>

            <BandcampWrap>
              <iframe
                style={{ border: 0, width: '350px', height: '470px' }}
                src="https://bandcamp.com/EmbeddedPlayer/album=3728223604/size=large/bgcol=ffffff/linkcol=333333/tracklist=false/transparent=true/"
                seamless
                title="T.R.A.N.C.E. (Pleasure/Perspective) by Julia E. Dyck & Diana Duta"
              >
                <a href="https://bbjtc.bandcamp.com/album/t-r-a-n-c-e-pleasure-perspective">
                  T.R.A.N.C.E. (Pleasure/Perspective) by Julia E. Dyck &amp; Diana Duta
                </a>
              </iframe>
            </BandcampWrap>

            {/* <StillRow>
              <StillImg src={still1} alt="Pleasure/Perspective visual still" />
              <StillImg src={still2} alt="Pleasure/Perspective visual still" />
              <StillImg src={still3} alt="Pleasure/Perspective visual still" />
            </StillRow> */}

            <h3>Hosted and supported by</h3>
            <SupporterList>
              {supporters.map((s) => (
                <SupporterItem key={s}>{s}</SupporterItem>
              ))}
            </SupporterList>
          </Body>
        </Wrapper>
      </DeskWrap>
      <Footer />
    </>
  );
};

const DeskWrap = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  max-width: 100vw;
  overflow-x: hidden;

  @media (min-width: 1000px) {
    flex-direction: row;
  }
`;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 90vh;
  width: 100%;
  max-width: 100%;
  overflow-x: hidden;

  @media (min-width: 1000px) {
    padding: 2rem;
  }
`;

const Body = styled.div`
  font-family: var(--font-body);
  width: 95%;
  padding: 0 1rem;
  max-width: 100%;

  h1 {
    font-size: 1.8rem;
    margin-bottom: 0.4rem;
    color: #333;
  }

  h3 {
    font-size: 1.2rem;
    margin: 1.75rem 0 0.75rem;
    color: #333;
  }

  p {
    line-height: 1.7;
    margin-bottom: 1.1rem;
    color: #444;
  }

  @media (min-width: 1000px) {
    max-width: 70ch;
    padding: 0 1rem;
  }
`;

const Sub = styled.p`
  font-style: italic;
  font-size: 1.05rem;
  color: #666;
  margin: 0 0 1.25rem;
`;

const ImageRow = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 1rem;
  margin: 1.5rem 0;

  @media (min-width: 700px) {
    grid-template-columns: 1fr 1fr;
  }
`;

const Img = styled.img`
  width: 100%;
  border-radius: 0.5rem;
  display: block;
  ${({ wide }) => wide && `margin: 1.5rem 0;`}
`;

const BandcampWrap = styled.div`
  margin: 1.5rem 0;

  iframe {
    max-width: 100%;
  }
`;

const StillRow = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 0.75rem;
  margin: 1.25rem 0 2rem;
  background: #000;
  padding: 0.75rem;
  border-radius: 0.5rem;

  @media (min-width: 700px) {
    grid-template-columns: 1fr 1fr 1fr;
  }
`;

const StillImg = styled.img`
  width: 100%;
  display: block;
  border-radius: 0.25rem;
`;

const SupporterList = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin: 0.75rem 0 2rem;
`;

const SupporterItem = styled.span`
  border: 1px solid #000;
  border-radius: 999px;
  padding: 6px 14px;
  font-size: 0.9rem;
  color: #333;
`;

export default Trance;
